import script from "./action-bar.vue?vue&type=script&setup=true&lang=js"
export * from "./action-bar.vue?vue&type=script&setup=true&lang=js"

import "./action-bar.vue?vue&type=style&index=0&id=d822e841&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d822e841"]])

export default __exports__